import moment from 'moment';
import { BILL_ALLOCATION_STATE } from 'src/api/billAutomation/bills';

/**
 * The AppFolio charge on date per allocation table on the Bills page (LB-6118, requested by Haley): the date the
 * table's charges post on in AppFolio. It is the same appfolio-service bill setting Apply Billing reads and overrides,
 * keyed by the allocation bill, so both screens show and change one value.
 */

/** A month key (year * 12 + month - 1, as monthKeys.js keeps them) as the year and month appfolio-service asks for. */
const fromMonthKey = key => key === null || key === undefined ? null : {
  allocationCycleYear: Math.floor(key / 12),
  allocationCycleMonth: key % 12 + 1
};

/**
 * The month the table's charges are billed in, which the default date is worked out from, or null when it can't be
 * told from here.
 * - Scheduled for a later month (LB-6009): that month.
 * - Saved in a month other than the company's month in progress: unknown here. Only one month is open at a time, so
 *   that is a closed month, where the date is shown and not changed.
 * - Otherwise the month in progress: the open month, which is where Allocate files it and where it was allocated.
 */
export function chargeOnMonthOf(table, saved, monthInProgress) {
  if (table !== null && table !== void 0 && table.scheduledFor) {
    const scheduled = moment(table.scheduledFor, 'YYYY-MM-DD');
    return scheduled.isValid() ? {
      allocationCycleYear: scheduled.year(),
      allocationCycleMonth: scheduled.month() + 1
    } : null;
  }
  if (saved !== null && saved !== void 0 && saved.isHistoricalAllocationCycle) return null;
  return fromMonthKey(monthInProgress);
}

/**
 * Whether the date can no longer be changed here. Where Apply Billing locks the table (a billed, locked or closed
 * table), and once it is approved or skipped too: approving sends the charges to AppFolio with the date they had, and
 * a later change would not reach them.
 */
export function isChargeOnLocked(table, saved) {
  if (!table) return true;
  if (table.isApproved || table.allocationState === BILL_ALLOCATION_STATE.skipped) return true;
  return (saved === null || saved === void 0 ? void 0 : saved.isEditable) === false;
}

/** Whether the table can carry a date at all: tied to a property utility, and one the allocation service can work out. */
export function takesChargeOnDate(table) {
  return !!(table !== null && table !== void 0 && table.propertyId) && !!(table !== null && table !== void 0 && table.utilityId) && !table.needsProperty && !table.needsUtility && table.isComputable !== false;
}